// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchBar_searchInput__8bmnW","icon":"SearchBar_icon__BJKRZ","icon2":"SearchBar_icon2__HPz7A"};